var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quillEditor',{style:(_vm.styleProp),attrs:{"disabled":_vm.readonly,"options":_vm.editorOption},on:{"change":_vm.onEditorChange},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }